import * as yup from "Utils/yup";
import { AiConfigurationFormData } from "./types";

export const AiConfigurationFormSchema: yup.SchemaOf<AiConfigurationFormData> =
  yup.object({
    ai_enabled: yup.boolean().required(),
    generate_package_overview_enabled: yup.boolean().required(),
    generate_software_info_enabled: yup.boolean().required(),
  });
